import Route from '@ember/routing/route';

export default class MetricLibraryIndexRoute extends Route {}
